import { Box, Paper } from '@mui/material';
import EnhancedMvpChatAgent from '@src/App/Components/_UnderConstruction/MvpChatAgent-2/EnhancedMvpChatAgent';
import React from 'react';

export default function ChatAgentSection() {
    return (
        <Box sx={{ mb: 5 }}>
            <EnhancedMvpChatAgent fullWidth={true} />
        </Box>
    );
}
